import { Link } from "react-router-dom";
import { ArrowUpRight, Shield, Search, Sparkles, Archive } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BArecordMark } from "@/components/BArecordMark";

const features = [
  { icon: Archive, title: "Capture everything", desc: "Emails, meetings, calls, chats, and notes — preserved with structured metadata." },
  { icon: Shield, title: "AI risk scoring", desc: "AI automatically scores compliance risk on every record — no manual review." },
  { icon: Search, title: "Ask in plain English", desc: "Search and question your entire communication history conversationally." },
  { icon: Sparkles, title: "Executive briefings", desc: "Generate summaries and leadership briefings in seconds." },
];

export function SafeMeSection() {
  return (
    <section id="safeme" className="bg-black py-24 lg:py-36 border-t border-white/10" data-testid="safeme-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 items-start">
          <Reveal>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 px-3 py-1 mb-6">
              <BArecordMark size={13} className="text-paper" />
              <span className="text-xs uppercase tracking-widest text-paper">BArecord</span>
              <span className="text-[9px] uppercase tracking-widest bg-white/10 text-paper rounded-full px-1.5 py-0.5">Powered by AI</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-paper leading-[0.95] max-w-[14ch]">
              Never lose a conversation again.
            </h2>
            <p className="mt-6 text-sm text-fog leading-relaxed max-w-md">
              BArecord — Business Archive Record — is Aliwer's secure communications-intelligence
              platform. It captures, secures, searches, and preserves every business communication —
              closing the compliance gaps and data loss created when employees leave or tools sprawl.
            </p>
            <Link
              to="/barecord"
              data-testid="safeme-cta"
              className="mt-9 group inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium pl-6 pr-5 py-3.5 hover:bg-white transition-colors"
            >
              Open BArecord
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>

          <div className="grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 rounded-2xl overflow-hidden">
            {features.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.06}>
                <div className="h-full bg-surface p-7 hover:bg-[#232326] transition-colors duration-500">
                  <f.icon size={20} className="text-paper mb-6" strokeWidth={1.4} />
                  <h3 className="font-display text-lg tracking-tight text-paper mb-2">{f.title}</h3>
                  <p className="text-sm text-fog leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
